"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateFieldContext = exports.defaultContextValue = void 0;

var react_1 = require("react");

exports.defaultContextValue = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onDateChange: function onDateChange() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onEndDateChange: function onEndDateChange() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onDatePick: function onDatePick() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onMonthPick: function onMonthPick() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onYearPick: function onYearPick() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onRangePick: function onRangePick() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsShowing: function setIsShowing() {},
  dateOptions: {
    weekStartsOn: 1
  }
};
exports.DateFieldContext = (0, react_1.createContext)(exports.defaultContextValue);